var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 67C52.0015 67 67 52.0015 67 33.5C67 14.9985 52.0015 0 33.5 0C14.9985 0 0 14.9985 0 33.5C0 52.0015 14.9985 67 33.5 67Z",
    fill: "#36AF6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8364 48C27.7697 48 27.7028 47.9983 27.6358 47.995C27.0449 47.966 26.4672 47.8069 25.9422 47.5287C25.4172 47.2505 24.9574 46.8598 24.5944 46.3834L18.8631 38.8677C18.1957 37.9906 17.8968 36.8793 18.0317 35.7776C18.1667 34.6759 18.7247 33.6738 19.5831 32.9911L19.7893 32.8274C20.6494 32.1468 21.7391 31.8419 22.8193 31.9796C23.8995 32.1172 24.8821 32.6862 25.5516 33.5618C25.8746 33.9854 26.2835 34.3328 26.7504 34.5803C27.2173 34.8277 27.7311 34.9694 28.2566 34.9955C28.7822 35.0216 29.307 34.9316 29.7953 34.7317C30.2836 34.5317 30.7237 34.2265 31.0856 33.837L42.7232 21.3077C43.094 20.9085 43.5383 20.5876 44.0308 20.3635C44.5232 20.1394 45.0541 20.0164 45.5931 20.0015C46.1322 19.9867 46.6688 20.0803 47.1724 20.277C47.676 20.4737 48.1366 20.7696 48.528 21.1479L48.718 21.3315C49.5085 22.0953 49.9691 23.1482 49.9985 24.2584C50.0279 25.3686 49.6236 26.4453 48.8747 27.2515L30.8163 46.6922C30.4329 47.1054 29.9709 47.4345 29.4585 47.6594C28.9462 47.8842 28.3942 48.0001 27.8364 48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.7a6f572ee29858052064eb2ea8de6439.svg";
export { ForwardRef as ReactComponent };